module.exports = __webpack_public_path__ + "static/media/mc.6281222a.svg";